<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =

[{"num_cand":"U2FsdGVkX1/m4ptAhL11UTlIFRJt2FggOSGcS56HiM4=","cpf":"U2FsdGVkX19htCgx9IQOCgjuEkkB5nvrGD/s5XhY4BQ="},{"num_cand":"U2FsdGVkX183sjvc/XXH6rlU9nPY4Hu8M/yAlNEEbz8=","cpf":"U2FsdGVkX19DAvr8RkHbzqh5Fo+vjNvWaPxmhfALTEg="},{"num_cand":"U2FsdGVkX1+TewWP1gx1AUuqRCGrZiO1Vl4vBN7LJOg=","cpf":"U2FsdGVkX18i1Tgme/NDS1XtmkR6O2j+re3W8UyVGeY="},{"num_cand":"U2FsdGVkX18P55nAkMLM78HdKizLoQYPkYx9VLSM+DU=","cpf":"U2FsdGVkX1+i46HSCX7tHrRvT0zWyEf1IdtDFwCXtxE="},{"num_cand":"U2FsdGVkX1+Izfz1VU/sMcNywf5jP1uh1+xuouCfLQI=","cpf":"U2FsdGVkX187I6fsS+PrhydrPWBfn5wNa+nN9Ef3eGU="},{"num_cand":"U2FsdGVkX18Q+lwxaeWabi4mWIsImPvwQxRwBHB2INc=","cpf":"U2FsdGVkX19wIEO2vBDW8KpjxTJVjmEXlqHfRks/tvM="},{"num_cand":"U2FsdGVkX1+P6iq6FiitpwsqlHAg6zQTrOPUjBf9w1M=","cpf":"U2FsdGVkX1/1y1rMPWNfIqjirzpKNdUse0D3v6fA24g="},{"num_cand":"U2FsdGVkX19dXcrT/3OyECswk9baSi5CXpgDGJhqvxo=","cpf":"U2FsdGVkX19VRoieJ94vqczvFrXmUWCHn2sUqLl06Gs="},{"num_cand":"U2FsdGVkX18iiG1YQUbk6USLLPKvVlOWNCsKntqiHfg=","cpf":"U2FsdGVkX19dWoQvZ1sNpHa06iMixHWnGZ1r7qmkZlU="},{"num_cand":"U2FsdGVkX18m5nv86Zog50bo2h3VTdv3gX4qJsiIaDg=","cpf":"U2FsdGVkX1/EARdOvZjNBbfZOnh3XMH6puaOwM6YOE0="},{"num_cand":"U2FsdGVkX1+rwoE9MxXorx6ubvQD2VwxP7zlIWCnX/Y=","cpf":"U2FsdGVkX1+/XcIkFM8a2K63VqKbIX0IAmKoOvLpBDI="},{"num_cand":"U2FsdGVkX1+7IT0gq5FmFwYAk7ac3ouqGBCemRIfnV4=","cpf":"U2FsdGVkX1/oRjcih/hrSsFga3UPytEXUMiTq24q98g="},{"num_cand":"U2FsdGVkX1+tQ1e6cZO7+hhonUVA7flqyljm4iyQUPg=","cpf":"U2FsdGVkX19T5rv3lGbZqDxPZ5bQ6kV2ndjJDd4SHf0="},{"num_cand":"U2FsdGVkX19PuRzDgPYCdIz8PsQaEaGtfoTHu27AlzI=","cpf":"U2FsdGVkX19Gsnns6APEUCT0nEEWkXey6BBEMfKXM8k="},{"num_cand":"U2FsdGVkX18POT1M/ldwOXTab7bKK3t7PMYmFg85gLs=","cpf":"U2FsdGVkX193pHVNrQl0hyAN7kq6tE1gEslOGMQj4CI="}]
      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2207/rec_hetero/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
